import React from 'react'

interface Props {
  className?: string;
}

export const Checkmark = (props: Props) => {
  return (
    <svg className={props.className} width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 4L0 6L6 12L16 2L14 0L6 8L2 4Z" fill="#76767D" />
    </svg>
  )
}
